// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d3e20430","732":"38e76b81","977":"b062df75"}[chunkId] + ".chunk.js";
};